<div class="body">

    <ng-container *ngIf="added.length > 0 || removed.length > 0; else noteNotChanged">

        <div class="text-block added">

            <div class="line" *ngFor="let line of added; let i = index">
    
                <div class="index">{{i}}</div>
                <div class="line" [innerHtml]="line"></div>
    
            </div>
    
        </div>
    
        <div class="text-block removed">
    
            <div class="line" *ngFor="let line of removed; let i = index">

                <div class="index">{{i}}</div>
                <div class="line" [innerHtml]="line"></div>

            </div>
    
        </div>

    </ng-container>

</div>

<ng-template #noteNotChanged>

    <div class="note-not-changed-hint">

        <span>
            Die Notiz wurde nicht verändert
        </span>

    </div>

</ng-template>
